import { createContext, useContext, useState } from "react";
import { useDispatch } from "react-redux";
import SuccessPopup from "../components/SuccessPopup";
import { getActiveCurrency } from "../utils/getActiveCurrency";
import { getActiveMarket } from "../utils/getActiveMarket";
import apiSlice from "../utils/store-slices/apiSlice";

const MultiMarketContext = createContext();

const marketCurrencyDictionary = {
	PL: "PLN",
	CZ: "CZK",
	SK: "EUR",
	HU: "HUF",
};

export const MultiMarketProvider = ({ children }) => {
	const dispatch = useDispatch();

	const [activeMarket, setActiveMarket] = useState(getActiveMarket());
	const [activeCurrency, setActiveCurrency] = useState(getActiveCurrency());

	const handleActiveMarketChange = (value) => {
		setActiveMarket(value);
		localStorage.setItem("activeMarket", value);

		setActiveCurrency(marketCurrencyDictionary[value]);
		localStorage.setItem("activeCurrency", marketCurrencyDictionary[value]);

		SuccessPopup("Zmieniono market");

		setTimeout(() => {
			dispatch(apiSlice.util.resetApiState());
			// reload
			window.location.reload();
		}, 500);
	};

	const handleActiveCurrencyChange = (value) => {
		setActiveCurrency(value);
		localStorage.setItem("activeCurrency", value);
		SuccessPopup("Zmieniono walutę");

		setTimeout(() => {
			dispatch(apiSlice.util.resetApiState());
			// reload
			window.location.reload();
		}, 500);
	};

	const value = {
		activeMarket,
		handleActiveMarketChange,
		activeCurrency,
		handleActiveCurrencyChange,
	};

	return (
		<MultiMarketContext.Provider value={value}>
			{children}
		</MultiMarketContext.Provider>
	);
};

export const useMarket = () => useContext(MultiMarketContext);
